module.exports = __webpack_public_path__ + "img/icon4.77065f62.png";